<div class="errwrap"><div class="errdiv1" id="errs"></div></div>

<div 
*ngIf="actionmode == 'Add' || actionmode == 'Edit'" 
class="searchdiv">
    <div class="card screen-wrapper">
        <div class="header headerdiv">
            <h1 class="screen-title">{{ screentitle }}</h1>
            <div class="button-wrapper bothbuttdiv2">
                <div 
                *ngIf="actionmode == 'Add' || actionmode == 'Edit'"
                 class="btn back-button button-margin">
                    <button class="btn btn-primary commonbutt" type="button" 
                    (click)="submitData1()">
                        <em class="fa fa-check"></em>&nbsp;Submit
                    </button>
                    <button class="btn btn-danger commonbutt" 
                    (click)="searchForm()" type="button">
                        <em class="fa fa-times"></em>&nbsp;Close
                    </button>
                </div>
            </div>
        </div>


        
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <!-- form starts  -->
                    <div class="form-div">
                        <div class="row">
                            <div class="m-portlet">
                                <div style="padding: 2% 2% 2% 2%">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label>TPM Journey Type</label>
                                            <select class="form-control" [(ngModel)]="screen_details.TPM_JOURNEY_TYPE">
                                                <option value="" selected disabled>--Select Journey Type --</option>
                                                <option value="I">
                                                    I
                                                </option>
                                                <option value="D">
                                                    D
                                                </option>
                                            </select>

                                        </div>

                                        <div class="col-md-3">
                                            <label>TPM Cabin Class</label>
                                            <select class="form-control" [disabled]="actionmode =='Edit'"
                                                [(ngModel)]="screen_details.TPM_CABIN_CLASS">
                                                <option value="" selected disabled> --Select Cabin Class -- </option>
                                                <option value="B"> B </option>
                                                <option value="E"> E</option>

                                            </select>
                                        </div>

                                    </div>
                                    <div class="row">

                                        <div class="col-md-3">
                                            <label>TPM Start Range</label>
                                            <input type="text" class="form-control m-input"
                                                [(ngModel)]="screen_details.TPM_START_RANGE"
                                                placeholder="Enter Conv Fee TPM Start Range ">
                                        </div>
                                        <div class="col-md-3">
                                            <label>TPM End Range</label>
                                            <input type="text" class="form-control m-input"
                                                [(ngModel)]="screen_details.TPM_END_RANGE"
                                                placeholder="Enter Conv Fee TPM End Range">
                                        </div>


                                    </div>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label>TPM Start Time</label>
                                            <input [(ngModel)]="screen_details.TPM_START_TIME"
                                                class="form-control m-input" type="text"
                                                placeholder="Enter TPM Start Time" />
                                        </div>

                                        <div class="col-md-3">
                                            <label>TPM End Time</label>
                                            <input [(ngModel)]="screen_details.TPM_END_TIME"
                                                class="form-control m-input" type="text"
                                                placeholder="Enter TPM End Time" />

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <label>Convienience Fee</label>
                                            <input [(ngModel)]="screen_details.CONVIENIENCE_FEE"
                                                class="form-control m-input" type="text"
                                                placeholder="Enter TPM Convienience Fee" />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div [hidden]="!viewpage" class="tdive">
    <div *ngIf="actionmode == 'view'" class="searchdiv">
        <div class="card screen-wrapper">
            <div style="border-bottom:1px solid #ddd9d9;margin-bottom: 15px; ">
                <h4 class="screen-title">{{ screentitle }}</h4>
                <div class="button-wrapper bothbuttdiv2">

                    <button style="margin-top: 8px" class="btn btn-danger commonbutt" (click)="searchForm()"
                        type="button">
                        <em class="fa fa-times"></em>&nbsp;Close
                    </button>

                </div>
            </div>
        </div>

        <table aria-describedby="convFeeTPMDetails" class="viewtable">
            <div *ngFor="let q of EditData">
                <tr>
                    <th scope="col">
                        <span class="vlbl">TPM Journey Type</span>
                    </th>
                    <td>
                        <span class="vVal">{{ q.TPM_JOURNEY_TYPE }}</span>
                    </td>
                </tr>

                <tr>
                    <th scope="col">
                        <span class="vlbl">TPM Start Range</span>
                    </th>
                    <td>
                        <span class="vVal">{{ q.TPM_START_RANGE }}</span>
                    </td>
                </tr>
                <tr>
                    <th scope="col">
                        <span class="vlbl">TPM End Range</span>
                    </th>
                    <td>
                        <span class="vVal"> {{ q.TPM_END_RANGE }} </span>
                    </td>
                </tr>
                <tr>
                    <th scope="col">
                        <span class="vlbl">TPM Cabin Class</span>
                    </th>
                    <td>
                        <span class="vVal"> {{ q.TPM_CABIN_CLASS}} </span>
                    </td>
                </tr>
                <tr>
                    <th scope="col">
                        <span class="vlbl">TPM Start Time</span>
                    </th>
                    <td>
                        <span class="vVal"> {{ q.TPM_START_TIME}} </span>
                    </td>
                </tr>
                <tr>
                    <th scope="col">
                        <span class="vlbl">TPM End Time</span>
                    </th>
                    <td>
                        <span class="vVal"> {{ q.TPM_END_TIME}} </span>
                    </td>
                </tr>
                <tr>
                    <th scope="col">
                        <span class="vlbl">Convienience Fee</span>
                    </th>
                    <td>
                        <span class="vVal"> {{ q.CONVIENIENCE_FEE}} </span>
                    </td>
                </tr>
            </div>
        </table>
    </div>
</div>


<div [hidden]="viewpage" *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
    <div class="headerdiv">
        <h1>{{ screentitle }}</h1>
        <div class="bothbuttdiv">
            <button class="btn btn-primary commonbutt" type="button" (click)="addForm()">
                <em class="fa fa-plus-circle"></em>&nbsp;Add New
            </button>
        </div>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12">
                <div class="form-div">
                    <div class="row">
                        <div class="m-portlet">
                            <div>
                                <div>
                                    <div class="wr15">
                                        <div class="instruct">
                                            <div class="int1" style="margin-left: 17px">
                                                <span class="inst" style="font-size: 12px"><strong> Instructions
                                                    </strong></span>
                                                <br />
                                                <span class="txt">
                                                    1. Select at least one value out of TPM Journey Type, Conv Fee TPM
                                                    Start Range, Conv Fee TPM End Range.

                                                </span>
                                                <br />
                                                <span class="txt">
                                                    2. You can also use a combination of the given fields to search
                                                </span>
                                                <br />
                                                <span></span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <label>TPM Journey Type</label>
                                                <select class="form-control" (change)="gotochangestatus(1)"
                                                    [(ngModel)]="search_details.TPM_JOURNEY_TYPE">
                                                    <option value=" " selected="" disabled="">--Select Journey Type --
                                                    </option>
                                                    <option value="I">
                                                        I
                                                    </option>
                                                    <option value="D">
                                                        D
                                                    </option>
                                                </select>

                                            </div>


                                            <div class="col-md-3">
                                                <label>TPM Cabin Class</label>
                                                <select class="form-control" [disabled]="actionmode =='Edit'"
                                                    [(ngModel)]="search_details.TPM_CABIN_CLASS">
                                                    <option value="" selected="true" disabled="">--Select Cabin Class--
                                                    </option>
                                                    <option value="B"> B </option>
                                                    <option value="E"> E</option>

                                                </select>
                                            </div>

                                        </div>
                                        <div class="row">

                                            <div class="col-md-3">
                                                <label>TPM Start Range</label>
                                                <input type="text" class="form-control m-input"
                                                    [(ngModel)]="search_details.TPM_START_RANGE"
                                                    placeholder="Enter Conv Fee TPM Start Range ">
                                            </div>
                                            <div class="col-md-3">
                                                <label>TPM End Range</label>
                                                <input type="text" class="form-control m-input"
                                                    [(ngModel)]="search_details.TPM_END_RANGE"
                                                    placeholder="Enter Conv Fee TPM End Range">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <label>TPM Start Time</label>
                                                <input [(ngModel)]="search_details.TPM_START_TIME"
                                                    class="form-control m-input" type="text"
                                                    placeholder="Enter TPM Start Time" />
                                            </div>

                                            <div class="col-md-3">
                                                <label>TPM End Time</label>
                                                <input [(ngModel)]="search_details.TPM_END_TIME"
                                                    class="form-control m-input" type="text"
                                                    placeholder="Enter TPM End Time" />

                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <label>Convienience Fee</label>
                                                <input [(ngModel)]="search_details.CONVIENIENCE_FEE"
                                                    class="form-control m-input" type="text"
                                                    placeholder="Enter TPM Convienience Fee" />

                                            </div>
                                        </div>
                                        <div class="btn clear-button button-margin">
                                            <button style="margin-top: 20px;" class="btn btn-primary commonbutt"
                                                (click)="searchData()" type="button">
                                                <em class="fa fa-search "></em>&nbsp;Search
                                            </button>
                                        </div>
                                    </div>
                                    <br />

                                    <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">
                                        <table aria-describedby="convFeeTPMData" class="table table-striped"
                                            [mfData]="serachtabledata" [mfRowsOnPage]="5">

                                            <tr>
                                                <th scope="col" style="width: 20%">Actions</th>

                                                <th scope="col" style="width: 20%">
                                                    <mfDefaultSorter by="email">Journey Type</mfDefaultSorter>
                                                </th>
                                                <th scope="col" style="width: 20%">
                                                    <mfDefaultSorter by="email">Start Range</mfDefaultSorter>
                                                </th>
                                                <th scope="col" style="width: 20%">
                                                    <mfDefaultSorter by="email">End Range</mfDefaultSorter>
                                                </th>
                                                <th scope="col" style="width: 20%">
                                                    <mfDefaultSorter by="email">TPM Cabin Class</mfDefaultSorter>
                                                </th>
                                                <th scope="col" style="width: 20%">
                                                    <mfDefaultSorter by="email">Start Time</mfDefaultSorter>
                                                </th>
                                                <th scope="col" style="width: 20%">
                                                    <mfDefaultSorter by="email">End Time</mfDefaultSorter>
                                                </th>
                                                <th scope="col" style="width: 20%">
                                                    <mfDefaultSorter by="email">Convienience Fee</mfDefaultSorter>
                                                </th>

                                            </tr>


                                            <tr *ngFor="
                          let item of (serachtabledata
                            | paginate: { itemsPerPage: 10, currentPage: p })
                        ">

                                                <td>
                                                    <button class="btn btn-default btn-circle" type="button"
                                                        (click)="showFormData(item,1)">
                                                        <em class="fa fa-eye"></em>
                                                    </button>

                                                    <button class="btn btn-default btn-circle" type="button"
                                                        (click)="showFormData(item,2)">
                                                        <em class="fa fa-pencil"></em>
                                                    </button>

                                                </td>

                                                <td>{{item.TPM_JOURNEY_TYPE}}</td>
                                                <td>{{item.TPM_START_RANGE}}</td>
                                                <td>{{item.TPM_END_RANGE}}</td>
                                                <td>{{item.TPM_CABIN_CLASS}}</td>
                                                <td>{{item.TPM_START_TIME}}</td>
                                                <td>{{item.TPM_END_TIME}}</td>
                                                <td>{{item.CONVIENIENCE_FEE}}</td>

                                            </tr>

                                            <tfoot>
                                                <tr>
                                                    <td colspan="5">
                                                        <pagination-controls (pageChange)="p = $event">
                                                        </pagination-controls>
                                                    </td>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>
                                    <div *ngIf="loader">
                                        <div style="margin:auto; text-align: center">
                                            <img src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                                                width="8%" height="8%" alt="Loader" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>